/** Código devolvido pela API em manutenção programada (login). */
export const USER_MAINTENANCE_PARAMETER = 'User.Maintenance';

export const USER_MAINTENANCE_LOGIN_TOAST_ID = 'login-user-maintenance';
